import { CSS } from '@stitches/react'
import { AreaSPLine } from 'Components/Elements/Chart/AreaSPLine'
import { Pie } from 'Components/Elements/Chart/Pie'
import { Options } from 'highcharts'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReducedThreatGroupsBreakdown } from '../../../../features/home/routes/Home/types'
import { AreaSPLineData } from '../AreaSPLine/types'
import { PiePlaceholderStyled, ThreatGroupsStyled } from './TrendsAndThreatGroups.styled'
import { LoadingIcon, useResponsive } from '@clickcease/cc-client-components-lib'
import { LoaderWrapper } from 'Features/home/components/OverallDomainsPreformance/DomainsTable.styled'

export const TrendsAndThreatGroups = ({
  css,
  children,
  chartCSS,
  pieCSS,
  threatGroupsBreakdown,
  areaSPLineData,
  AreaSPLineOptions,
  pieOptions,
  pieSize,
  isChartLoading,
  isPieLoading,
}: {
  css?: CSS
  children?: React.ReactNode
  chartCSS?: CSS
  pieCSS?: CSS
  threatGroupsBreakdown?: ReducedThreatGroupsBreakdown
  areaSPLineData: AreaSPLineData
  AreaSPLineOptions?: Options
  pieOptions?: Options
  pieSize?: number
  isPieLoading?: boolean
  isChartLoading?: boolean
}) => {
  const { t } = useTranslation('home')
  const { windowWidth } = useResponsive()
  return (
    <ThreatGroupsStyled css={css}>
      {windowWidth && !isChartLoading ? (
        <AreaSPLine chartCSS={chartCSS} data={areaSPLineData} options={AreaSPLineOptions} />
      ) : (
        <LoaderWrapper css={{ height: '300px', width: '100%', maxWidth: '420px' }}>
          <LoadingIcon />
        </LoaderWrapper>
      )}
      {!isPieLoading && windowWidth ? (
        <>
          {threatGroupsBreakdown?.data.length ? (
            <Pie
              chartCSS={pieCSS}
              data={threatGroupsBreakdown?.data}
              drillDownSeries={threatGroupsBreakdown?.drillDownSeries}
              total={{ title: t('total_threats'), value: threatGroupsBreakdown?.totalThreats || 0 }}
              options={pieOptions}
              pieSize={pieSize}
            />
          ) : (
            <PiePlaceholderStyled css={{ flex: '1 1 25%' }}></PiePlaceholderStyled>
          )}
        </>
      ) : (
        <LoaderWrapper css={{ height: '300px', width: '100%', maxWidth: '420px' }}>
          {isPieLoading && <LoadingIcon />}
        </LoaderWrapper>
      )}
      {children}
    </ThreatGroupsStyled>
  )
}
